import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  wrapper: {
    display: "flex",
    justifyContent: "start",
    flexWrap: "wrap",
    flexDirection: { xs: "column", sm: "row" },
    gap: "3%",
  },

  input: {
    flexBasis: { xs: "100%", sm: "75%", lg: "34%" },
    margin: "0 0 24px 0",
  },

  selectWrapper: {
    minWidth: "80px",
    borderTopRightRadius: "0px",
  },

  phoneCodeError: {
    whiteSpace: "nowrap",
  },

  phoneCode: {
    maxWidth: "50px",
  },

  address: {
    flexBasis: "100%",
  },

  select: {
    flexBasis: "45%",
  },

  checkbox: {
    flexBasis: "100%",
  },

  withHelperText: {
    display: "flex",
    flexDirection: "column",
  },

  fieldHelperText: {
    flexDirection: "column",
    color: "custom.text.dark",
    opacity: "0.6",
    fontSize: "14px",
    fontWeight: 400,
    marginTop: "10px",
  },

  emailLine: {},
  otpLabel: {
    marginBottom: "8px",
    width: "200px",
    textAlign: "left",
  },

  otpSend: {
    color: "custom.text.dark",
    opacity: "0.6",
    marginTop: "-19px",
    fontSize: "14px",
    fontWeight: 400,
  },

  pwdErrorMsg: {
    position: { xs: "static", marginTop: "-6px" },
  },

  description: {
    color: "custom.text.light",
    fontSize: "14px",
    fontWeight: 600,
    marginTop: "10px",
    textAlign: "center",
  },

  selfDec: {
    fontWeight: "600",
    fontSize: "20px",
    marginBottom: "15px",
  },

  checkBoxHeading: {
    color: "error.main",
  },
});

export default styles;
